import { AppThunk } from '@lib/state/types';
import {
    OrderPost,
    OrderCheck,
    ActionTypes,
    ServiceCheck,
    CompleteOrderRequest,
} from '@lib/domain/order';
import {
    CreateOrderResponse,
    ListOrderRespone,
    GetListOrderPayload,
    CheckOrderRequest,
} from '@lib/state/Order/types';
import { OrderActions } from '../_actions';
import OrderReducers from './OrderReducers';

/**
 * Create Order
 * @param {OrderPost} orders
 * @return {AppThunk<Promise<CreateOrderResponse>>}
 */
export const createOrder: (
    orders: OrderPost,
) => AppThunk<Promise<CreateOrderResponse>> = (orders) => async (
    dispatch,
    _getState,
    container,
): Promise<CreateOrderResponse> => {
    const { channel } = OrderReducers.getReducerState(_getState());
    // create order
    const res: CreateOrderResponse = await container.cradle.orderRepository.createOrder(
        { ...orders, channel },
    );
    return res;
};

export const getListOrder: (
    pageInfo: GetListOrderPayload,
) => AppThunk<Promise<void>> = (pageInfo) => async (
    dispatch,
    _getState,
    container,
): Promise<void> => {
    // get list order
    const orders: ListOrderRespone = await container.cradle.orderRepository.getListOrder(
        pageInfo,
    );

    // set order list to redux state
    dispatch(OrderActions.getOrders(orders));
};

export const checkOrders = (
    payload: CheckOrderRequest[],
): AppThunk<Promise<OrderCheck[]>> => async (
    dispatch,
    _getState,
    container,
): Promise<OrderCheck[]> => {
    // Check list orders
    const checkedList = await Promise.all(
        payload.map((item: CheckOrderRequest) =>
            container.cradle.orderRepository.checkOrder(item),
        ),
    );
    let mergeValue = [];
    const mapListOrder = {} as Record<ActionTypes, OrderCheck>;
    const servicesList = [];
    checkedList.forEach(({ services, in_progress }) => {
        mergeValue.push(...in_progress);
        servicesList.push(...services);
    });
    if (servicesList.length > 0) {
        servicesList.forEach((item: ServiceCheck) => {
            if (!mergeValue[item.action_type] && !item.enabled) {
                mapListOrder[item.action_type] = {
                    url: '',
                    action_type: item.action_type,
                    count: 0,
                };
            }
        });
        if (mergeValue.length > 0) {
            mergeValue.forEach((item: OrderCheck) => {
                mapListOrder[item.action_type] = item;
            });
        }
        if (Object.keys(mapListOrder).length !== mergeValue.length) {
            mergeValue = Object.keys(mapListOrder).map(
                (key) => mapListOrder[key],
            );
        }
    }
    dispatch(OrderActions.checkOrder(mergeValue));
    return mergeValue;
};

export const checkPosts = (
    payload: CheckOrderRequest[],
): AppThunk<Promise<Record<string, Record<ActionTypes, number>>>> => async (
    dispatch,
    _getState,
    container,
): Promise<Record<string, Record<ActionTypes, number>>> => {
    // Check list orders
    const checkedList = await Promise.all(
        payload.map((item: CheckOrderRequest) =>
            container.cradle.orderRepository.checkOrder(item),
        ),
    );
    const mergeValue = {};
    checkedList.forEach(({ in_progress }) => {
        if (in_progress.length > 0) {
            in_progress.forEach((checkPost) => {
                if (!mergeValue[checkPost.url]) {
                    mergeValue[checkPost.url] = {};
                }
                mergeValue[checkPost.url][checkPost.action_type] =
                    checkPost.count;
            });
        }
    });
    dispatch(OrderActions.setCheckPosts(mergeValue));
    return mergeValue;
};

export const completeOrder: (
    order: CompleteOrderRequest,
) => AppThunk<Promise<CreateOrderResponse>> = (orders) => async (
    dispatch,
    _getState,
    container,
): Promise<CreateOrderResponse> => {
    // create order
    const res: CreateOrderResponse = await container.cradle.orderRepository.completeOrder(
        orders,
    );
    dispatch(OrderActions.addOrderIdNotLoggedIn(res.id));
    dispatch(OrderActions.setIsNewOrder(true));
    return res;
};

export default {
    createOrder,
    getListOrder,
    checkOrders,
    checkPosts,
    completeOrder,
};
